module.exports = __webpack_public_path__ + "static/media/crop.51c1e88c.svg";